import { createApp } from 'vue'
import '@/styles/main.css'
import '@supplier/styles/base.scss'
import i18n from '@supplier/plugins/i18n'
import { router } from '@supplier/router'
import { createPinia } from 'pinia'
import VueDOMPurifyHTML from 'vue-dompurify-html'

import { domPurifyHooks } from '@/utils/domPurifyHooks'
import { ensureOverlayLayers } from '@/utils/overlayLayers'

import SupplierApp from '@supplier/SupplierApp.vue'

import { createAppUiKit } from '@/plugins/uiKitPlugin'
import { userpilot } from '@/services/userpilot'

function applyLightTheme() {
  document.documentElement.setAttribute('data-theme', 'light')
  try {
    localStorage.setItem('activeTheme', 'light')
  } catch (error) {
    console.error(error)
  }
}

applyLightTheme()
ensureOverlayLayers()
userpilot.initialize()

createApp(SupplierApp)
  .use(createPinia())
  .use(i18n)
  .use(createAppUiKit({ router }))
  .use(VueDOMPurifyHTML, {
    hooks: domPurifyHooks,
    namedConfigurations: {
      link: { ADD_ATTR: ['target'] },
    },
  })
  .use(router)
  .mount('#supplier-app')
